export default __webpack_public_path__ + "static/media/addFilter.6f1ed111.svg";